<!--
/*******************************************************************************
*@ 컴포넌트명   : ApprovalDetail.vue
*@ 컴포넌트설명 : 결재상세조회(신청내역,결재진행)
*@ 사용전문     : RCA040DA40 - 결재상세 조회
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div>
    <!-- 신청내역 -->
    <div class="detail-dropdown-box">
      <div class="header">
        <div class="tit">{{ /*신청 내역*/ $t("PCOP-02-01-02-03") }}</div>
        <i class="icon icon-dropdown-m-arrow" :class="{ rotate: !show1 }" @click="show1 = !show1" />
      </div>
      <div class="content" v-if="show1">
        <dl class="dlist dlist-item--type4">
          <dt>{{ /*등록자*/ $t("PCOP-02-01-02-04") }}</dt>
          <dd>{{RCA040DA40Response.regiWWWBnkgLginID}}</dd>
          <dt>{{ /*등록 시간*/ $t("PCOP-02-01-02-05") }}</dt>
          <dd>{{RCA040DA40Response.aprvalRegiYmd}}</dd>
          <dt>{{ /*등록 메모*/ $t("PCOP-02-01-02-06") }}</dt>
          <dd>{{RCA040DA40Response.aprvalMemoCtnt}}</dd>
        </dl>
      </div>
    </div>
    <!-- 결재 진행 -->
    <div class="detail-dropdown-box">
      <div class="header">
        <div class="tit">{{ /*결재 진행*/ $t("PCOP-02-01-02-07") }}</div>
        <i class="icon icon-dropdown-m-arrow" :class="{ rotate: !show2 }" @click="show2 = !show2" />
      </div>
      <div class="content" v-if="show2">
        <dl class="dlist dlist-item--type4 approval">
          <template v-for="(data, i) of RCA040DA40Response.list">
            <dt :key="`dt${i}`">{{i+1}}{{/*단계*/$t("MCOM-0000012")}}</dt>
            <dd :key="`dd${i}`" v-if="data.aprvalPnm">
              {{data.aprvalPnm}} {{data.isHoAprvalUser ? /*한국본사*/$t("MCOM-0000013"): ''}}
              {{data.prcssStusDstNm != '' ? `/${$t(data.prcssStusDstNm)}` : ''}}
              <template
                v-if="data.aprvalYmd"
              >
                <br />
                ({{data.aprvalYmd}})
              </template>
              <!-- 추후 이미지 업데이트 예정 -->
              <div class="badge-group">
                <!-- 현재 상태-->
                <i class="icon icon-me" v-if="data.aprvalPsn==regiWwwBnkgLginId" />
                <!-- 완료 상태-->
                <i class="icon icon-com" v-if="data.targetYn=='Y'" />
              </div>
            </dd>
            <dd :key="`dd${i}`" v-else class="etc">N/A</dd>
          </template>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { aprvalParam } from "@/mixins/approval";
export default {
  mixins: [aprvalParam],
  computed: {
    ...mapFields("admin/approvalInfo", ["RCA040DA40Response"]),
    ...mapFields(["sessionInfo"]),
  },
  data() {
    return {
      show1: true,
      show2: true,
    };
  },
};
</script>